import { getApiHeader } from "../../../gol-api/golApiCall";
import Logger from "../../../services/Logger";
import axios from "../../GolAxios";
import { createResponse, genderFromNamePrefix } from "../../functions";

export const createPassengerRequestPayload = async (person) => {
  const {
    birthDate,
    telephone,
    surname,
    givenName,
    namePrefix,
    email,
    passports,
    loyalties,
  } = person;

  const addCustomerSettings = passports.length > 0 || loyalties.length > 0;

  return {
    GolApi: {
      ...(await getApiHeader()),
      RequestDetail: {
        CreatePassengerRequest_2: {
          CreatePassenger: {
            Person: {
              Gender: genderFromNamePrefix(namePrefix),
              BirthDate: birthDate || "",
              NamePrefix: namePrefix,
              GivenName: {
                $t: givenName,
              },
              Surname: {
                $t: surname,
              },
              Telephone: {
                PhoneNumber: telephone,
              },
              Email: {
                $t: email,
              },
            },
          },

          CustomerSettings: {
            ...(addCustomerSettings
              ? {
                  ...(passports.length > 0
                    ? {
                        Passports: {
                          Passport: passports.map((passport) => ({
                            Number: passport.Number,
                            ValidityDate: passport.ValidityDate,
                            Citizenship: passport.Citizenship,
                            Issued: passport.Issued,
                          })),
                        },
                      }
                    : {}),
                  ...(loyalties.length > 0
                    ? {
                        Loyalties: {
                          LoyaltyProgram: loyalties.map((loyalty) => ({
                            Id: loyalty.Id,
                            MembershipId: loyalty.MembershipId,
                          })),
                        },
                      }
                    : {}),
                }
              : {}),
          },
        },
      },
    },
  };
};

export const modifyPassengerRequestPayload = async (passengerId, person) => {
  const {
    birthDate,
    telephone,
    surname,
    givenName,
    namePrefix,
    email,
    passports,
    loyalties,
  } = person;

  const addCustomerSettings = passports.length > 0 || loyalties.length > 0;

  return {
    GolApi: {
      ...(await getApiHeader()),
      RequestDetail: {
        ModifyPassengerRequest_2: {
          ModifyPassenger: {
            PassengerId: passengerId,
            Person: {
              Gender: genderFromNamePrefix(namePrefix),
              BirthDate: birthDate || "",
              NamePrefix: namePrefix,
              GivenName: {
                $t: givenName,
              },
              Surname: {
                $t: surname,
              },
              Telephone: {
                PhoneNumber: telephone,
              },
              Email: {
                $t: email,
              },
            },
          },

          CustomerSettings: {
            ...(addCustomerSettings
              ? {
                  ...(passports.length > 0
                    ? {
                        Passports: {
                          Passport: passports.map((passport) => ({
                            Number: passport.Number,
                            ValidityDate: passport.ValidityDate,
                            Citizenship: passport.Citizenship,
                            Issued: passport.Issued,
                          })),
                        },
                      }
                    : {}),
                  ...(loyalties.length > 0
                    ? {
                        Loyalties: {
                          LoyaltyProgram: loyalties.map((loyalty) => ({
                            Id: loyalty.Id,
                            MembershipId: loyalty.MembershipId,
                          })),
                        },
                      }
                    : {}),
                }
              : {}),
          },
        },
      },
    },
  };
};

export const cancelPassengerRequestPayload = async (passengerId) => {
  return {
    GolApi: {
      ...(await getApiHeader()),
      RequestDetail: {
        CancelPassengerRequest_1: {
          SelectedPassenger: {
            PassengerId: passengerId,
          },
        },
      },
    },
  };
};

const prepareFormVals = (passenger) => {
  const personInfo = Object.entries(passenger?.PassengerInfo?.Person).reduce(
    (acc, [key, value]) => {
      if (typeof value === "object" && value !== null && "$t" in value) {
        acc[key.charAt(0).toLowerCase() + key.slice(1)] = value.$t;
      } else if (
        typeof value === "object" &&
        value !== null &&
        "PhoneNumber" in value
      ) {
        acc[key.charAt(0).toLowerCase() + key.slice(1)] = value.PhoneNumber;
      } else {
        acc[key.charAt(0).toLowerCase() + key.slice(1)] = value;
      }

      acc.id = passenger?.PassengerInfo?.PassengerId as string;

      return acc;
    },
    {}
  );

  const passports = passenger?.CustomerSettings?.Passports?.Passport || [];
  const firstname = passenger?.PassengerInfo?.Person?.GivenName?.$t;
  const loyalties =
    passenger?.CustomerSettings?.Loyalties?.LoyaltyProgram || [];

  return { ...personInfo, passports, loyalties, firstname };
};

export async function createPassenger(payload) {
  const golRequest = await createPassengerRequestPayload(payload);

  try {
    const response = await axios.post("", golRequest);

    return createResponse(response);
  } catch (e) {
    Logger.error(e);
  }
}

export async function getPassenger(id) {
  const golRequest = {
    GolApi: {
      ...(await getApiHeader()),
      RequestDetail: {
        DetailPassengerRequest_2: {
          SelectedPassenger: { PassengerId: id },
        },
      },
    },
  };

  try {
    const response = await axios.post("", golRequest);

    const generalizedResponse = createResponse(response);
    const formattedData = prepareFormVals(generalizedResponse.data);

    const result = {
      ...generalizedResponse,
      data: formattedData,
    };

    return result;
  } catch (e) {
    Logger.error(e);
  }
}

export async function updatePassenger(id, payload) {
  const golRequest = await modifyPassengerRequestPayload(id, payload);

  try {
    const response = await axios.post("", golRequest);

    return createResponse(response);
  } catch (e) {
    Logger.error(e);
  }
}

export async function deletePassenger(id) {
  const golRequest = await cancelPassengerRequestPayload(id);

  try {
    const response = await axios.post("", golRequest);

    return createResponse(response);
  } catch (e) {
    Logger.error(e);
  }
}
